// extracted by mini-css-extract-plugin
export var dataCell = "_pb-2";
export var dataRow = "_pb-0";
export var headerRow = "_pb-1";